import { render, staticRenderFns } from "./newsInfo.vue?vue&type=template&id=b0913ade&scoped=true"
import script from "./newsInfo.vue?vue&type=script&lang=js"
export * from "./newsInfo.vue?vue&type=script&lang=js"
import style0 from "./newsInfo.vue?vue&type=style&index=0&id=b0913ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0913ade",
  null
  
)

export default component.exports